<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-after: always;"></div>
<p class="P_Normal__And__Justification__And__Left_Indent__And__Spacing_After__And__Tabs__And__Page_Break"> </p>
<p class="P_Normal__And__Justification__And__Left_Indent__And__Spacing_After__And__Tabs"> </p>
<p class="P_Normal__And__Justification__And__Left_Indent__And__Spacing_After__And__Tabs"> </p>
<p class="P_Normal__And__Justification__And__Left_Indent__And__Spacing_After__And__Tabs"> </p>
<p class="P_Normal__And__Justification__And__Left_Indent__And__Spacing_After__And__Tabs"> </p>
<p class="P_Normal__And__Justification__And__Left_Indent__And__Spacing_After__And__Tabs"> </p>
<p class="P_Normal__And__Justification__And__Left_Indent__And__Spacing_After__And__Tabs"> </p>
<p class="P_Normal__And__Justification__And__Left_Indent__And__Spacing_After__And__Tabs"> </p>
<p class="P_Normal__And__Centre_Alignment__And__Spacing_After__And__Tabs" id="auto_bookmark_toc_3"><span>To Jackie, who inspired the entire idea in the first place.</span></p>
<p class="P_Normal__And__Justification__And__Left_Indent__And__Spacing_After__And__Tabs"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0003.vue?73ebdda7